import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const avatar: CSSProperties = {
  display: "inline-block",
  verticalAlign: "middle",
  position: "relative",

  "& .overflow": {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    borderRadius: "50%",
    border: `2px solid ${greys.white}`,
    background: "#c4c4c4",
    color: greys.white,
  },
};

export const styles = {
  avatar,
};
